"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkData = exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['skin'], function (_a, carmiProps) {
    var skin = _a.skin;
    return {
        fillLayers: carmiProps.fillLayers,
        meshProps: carmiProps.meshProps,
        skin: skin,
    };
});
exports.css = withCompInfo_1.withCompInfo([], function (deps, carmiData) { return (__assign({ position: carmiData.isStateBoxStateType ? 'relative' : 'absolute', width: '100%', height: carmiData.isStateBoxStateType ? 'auto' : '100%' }, carmiData.cssVars)); });
exports.sdkData = withCompInfo_1.withCompInfo(['compData'], function (_a, carmiData) {
    var compData = _a.compData;
    return carmiData.isStateBoxStateType
        ? { isStateBoxStateType: carmiData.isStateBoxStateType }
        : {
            isStateBoxStateType: carmiData.isStateBoxStateType,
            name: compData.title,
        };
});
//# sourceMappingURL=SlideShowSlide.js.map